import { LoadingOutlined } from '@ant-design/icons';
import { useDispatch } from '@redux';
import { getJobStatus } from '@redux/config/actions';
import { Table } from 'antd';
import i18next from 'i18next';
import React, { useEffect, useState } from 'react';
import { Trans, useTranslation } from 'react-i18next';

const DataImportContent = ({
  jobId,
  setDisabled,
}: {
  jobId: string;
  setDisabled: (value: boolean) => void;
}) => {
  const { t } = useTranslation();
  const dispatch = useDispatch();

  const [status, setStatus] = useState('');
  const [loading, setLoading] = useState(true);
  const [failData, setFailData] = useState([]);

  const handleCheckJobStatus = () => {
    setDisabled(true);
    setLoading(true);
    dispatch(
      getJobStatus({
        data: {
          id: jobId,
        },
        options: {},
      }),
    )
      .then(({ payload }) => {
        if (payload?.status === 'FAIL') {
          setLoading(false);
          setDisabled(false);
          setStatus(payload?.status);
          setFailData(payload?.resultError);
        }
        if (payload?.status === 'COMPLETED') {
          setLoading(false);
          setDisabled(false);
          setStatus(payload?.status);
        }
      })
      .catch(() => {
        setLoading(false);
        setDisabled(false);
      });
  };

  useEffect(() => {
    if (jobId) {
      handleCheckJobStatus();
    }
  }, []);

  useEffect(() => {
    const interval = setInterval(() => {
      if (jobId && status !== 'FAIL' && status !== 'COMPLETED') {
        handleCheckJobStatus();
      } else {
        setLoading(false);
        clearInterval(interval);
      }
    }, 5000);
    return () => clearInterval(interval);
  }, [jobId, status]);

  const contentImport = (className, des) => {
    return (
      <div className={`${className} content-data`}>
        <Trans
          i18nKey={des}
          components={{
            bold: <span className="fw-600" />,
          }}
        />
      </div>
    );
  };

  const CONTENT = () => {
    switch (status) {
      case 'FAIL':
        return contentImport(
          'content-data__fail',
          'locationStocks.importError',
        );
      case 'COMPLETED':
        return contentImport(
          'content-data__success',
          'locationStocks.importSuccess',
        );
      default:
        return true;
    }
  };

  if (loading && status !== 'FAIL' && status !== 'COMPLETED') {
    return (
      <div className={`content-data__loading content-data`}>
        <div className="text-center">
          {t('locationStocks.loading')}
          &nbsp;
          <LoadingOutlined />
        </div>
      </div>
    );
  }

  const columns = [
    {
      title: t('locationStocks.spreadsheetRow'),
      name: '',
      dataIndex: '',
      render: (text, record, index) => (
        <div className="text-center">{index + 1}</div>
      ),
      width: 200,
    },
    {
      title: t('locationStocks.errorMessage'),
      name: i18next.language,
      render: (text) => <div className="text-center">{text}</div>,
      dataIndex: i18next.language,
    },
  ];

  return (
    <>
      {CONTENT()}
      {status === 'FAIL' && (
        <Table
          dataSource={failData || []}
          columns={columns}
          pagination={false}
          bordered
          className="mt-20"
        />
      )}
    </>
  );
};

export default DataImportContent;
